import React, { useEffect, useState } from 'react';
import './AIGenerate.css';

// AI生成：HTTPS 高位端口独立 Origin 内嵌（kuaituikeji.com:5681 → Nginx → 127.0.0.1:5679）
// - 5679 Nuxt 以根路径运行，5681 是独立 Origin，静态/API 相对路径天然正确
// - 5681 Nginx 已设置 CSP frame-ancestors https://kuaituikeji.com，允许主站嵌入
// - 备用入口 http://43.248.119.63:5679/ 仅在加载失败时提供（非主流程）
const GENERATE_URL = process.env.NODE_ENV === 'production'
  ? 'https://kuaituikeji.com:5681/'
  : 'http://43.248.119.63:5679/';
const FALLBACK_URL = 'http://43.248.119.63:5679/';
const LOAD_TIMEOUT_MS = 20000;

type LoadState = 'loading' | 'ready' | 'error';

const AIGenerate: React.FC = () => {
  const [loadState, setLoadState] = useState<LoadState>('loading');
  const [reloadKey, setReloadKey] = useState(0);

  // 加载超时保护：超时未触发 onLoad 视为连接失败（不做假状态）
  useEffect(() => {
    setLoadState('loading');
    const timer = setTimeout(() => {
      setLoadState(prev => (prev === 'loading' ? 'error' : prev));
    }, LOAD_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [reloadKey]);

  return (
    <div className="generate-embed-page">
      <div className="generate-embed-frame">
        {loadState !== 'ready' && (
          <div className="generate-embed-mask">
            {loadState === 'loading' ? (
              <>
                <span className="embed-spinner" aria-hidden="true" />
                <p>正在加载 AI生成工作台...</p>
              </>
            ) : (
              <>
                <p className="embed-error-text">AI生成工作台加载失败</p>
                <button
                  className="btn btn-primary"
                  onClick={() => setReloadKey(k => k + 1)}
                >
                  重新加载
                </button>
                <a
                  className="generate-fallback-link"
                  href={FALLBACK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  备用入口打开 ↗
                </a>
              </>
            )}
          </div>
        )}
        <iframe
          key={reloadKey}
          className="generate-embed-iframe"
          src={GENERATE_URL}
          title="AI生成工作台"
          onLoad={() => setLoadState('ready')}
          allow="clipboard-write"
        />
      </div>
    </div>
  );
};

export default AIGenerate;
